import Price from "components/Price/Price"
import { Col, Row, Table } from "elemental-react16"
import { Grid, Popup, GridColumn, Button, Card, Icon, Modal, Segment } from "semantic-ui-react"
import { Link, withRouter } from "react-router-dom"
import { observer } from "mobx-react"
import React, { Component } from "react"
import shop from "shop/shop"
import _ from "lodash"
import moment from "moment"
import "moment/locale/de"

import AccountReset from "components/Account/AccountReset"
import swal from "sweetalert"
import OrderModel from "../../../shop/OrderModel";


const setPasswordAsAdmin = ( account ) => {

  swal( {
      text            : "Passwort setzen",
      type            : "prompt",
      title           : "Neues Passwort",
      showCancelButton: true,
      closeOnConfirm  : false,
      closeOnCancel   : true,
    },
    newPassword => {
      if ( !newPassword ) return
      shop.fetch( `/shop/rest/security/user/${account.userid}/logins?passupdate=1`, {
        method: "POST",
        body  : JSON.stringify( {
          ...account,
          "password": newPassword,
          "newpass" : newPassword,
          "repeat"  : newPassword
        } )
      } )
        .then( res => {
          console.log( "PW CHANGE", res )
          swal( translate( "reset.success" ),
            translate( "Passwort erfolgreich gesetzt." ),
            "success" )
        } )
        .catch( err => {
          console.error( err )
          swal( "Fehler", "Leider konnte IhrPasswort nicht geändert werden", "error" )
        } )

    }
  )
}

export function fetchExtraOrderRessources( order ) {
  return shop.fetch( `/shop/rest/data/customer/current/extrainfo?start=0&count=50&subref=${order.map_id}` )
    .then( res => {
      order.extrainfo = res.map( data => new OrderPDF( data ) )
      return new OrderModel(order)
    } )
}

@withRouter
class Accounts extends React.Component {

  state = {
    loading : false,
    accounts: [],
    user: false,
  }

  async componentDidMount() {
    this.setState( { loading: true } )

    const users    = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22${shop.session.value.map_id}%22%7D`)

    var temp;
    if (users.length > 0) {
      this.user = users[0];
      temp = await shop.fetch( `/shop/rest/security/user/${users[0].id}/logins` )
    } else {
      temp = [];
    }

    const accounts = temp;
    console.log( { accounts } )
    this.setState( { accounts, loading: false } )
  }

  render() {
    const { accounts } = this.state
    return <div>
      <Segment.Group>
        {accounts.map( account => {
          return <Segment clearing key={account.login}>
            <Button floated={"right"} onClick={() => setPasswordAsAdmin( account )}>{translate( "change Password" )}</Button>
            <div className="pa2 b">{account.login} {account.contact}</div>
          </Segment>
        } )}
      </Segment.Group>
      <Segment.Group>
           <Segment>
            <a href={'/admin-ui/customers/' + shop.session.value.map_id}><Button floated={"right"}>{translate( "Logins verwalten" )}</Button></a>
            <div className="pa2 b">Administration</div>
          </Segment>
      </Segment.Group>
    </div>
  }
}

export const orderTypes = {
  0: "Order",
  1: "Delivery",
  2: "Invoice",
}

class OrderPDF {
  constructor( order ) {
    Object.assign( this, order )
    this.typeName = orderTypes[ order.type ] || "Unknown"
    this.url = `${shop.config.BASE}/shop/rest/data/customer/current/extraresources/${order.map_id}`
  }
}

@observer
export default class AccountPage extends Component {

  state = {
    session        : shop.session || {}, locations: [],
    orders         : [],
    current        : 0,
    showAddressBook: false,
    noMoreOrders   : false
  }

  loadMore = () => {
    let { orders, current } = this.state
    let pageSize = 20
    let start = current
    var filter = '';
    current = current + pageSize
    this.setState( { loading: true } )
    console.log('handUser State: ',shop.session.handId);
    if (shop.session.handId && !isNaN(Number(shop.session.handId))) {
      filter = '&filter=' + encodeURIComponent(JSON.stringify([{"op":"equals","field":"handId","value":shop.session.handId}]));
    }
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0${filter}` )
      .then( async res => {
        let extras = res.values.map( order => fetchExtraOrderRessources( order ) )
        await Promise.all( extras )
        console.log( "FROM API", { res } )
        orders = orders.concat( res.values )
        this.setState( { loading: false, current, orders } )
        if ( res.values.length === 0 ) {
          this.setState( { noMoreOrders: true, current, orders } )
        }
      } )
  }

  loadSession = ( session ) => {
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        this.setState( { locations } )
      } )
  }

  componentDidMount() {
    shop.events.authentified.add( this.loadSession )
    // this.loadSession()Top
  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  render() {
    let { locations, loading, noMoreOrders, orders } = this.state
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 6 )
    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      return (
        <Card key={key}
              sm="1/5">
          <Card.Header>
            <div className="pa3 b black-60">Lieferadresse</div>
          </Card.Header>
          <Card.Content>
            <Address location={location}/>
          </Card.Content>
        </Card>
      )
    } )

    return (
      <div className="container pt4">
        <h1 className="page-title"><i className="icon-vcard icon-lg"/><strong>{translate( "My Account" )}</strong></h1>
        <p>{translate( "View your customer data and recent orders" )}</p>
        <section className="pt3">

          {shop.session.handId && <div className="pb4">
            <div className="row-title tl">
              <h2>{translate( "Accounts" )}</h2>
            </div>
            <Accounts/>
          </div>}


          <div className="row-title tl">
            <h2>{translate( "Customer" )}</h2>
          </div>

          <div className="pb4">
            {translate( "Ihre Kundennummer" )}: #{shop.session.value.map_id}
          </div>
          <Card.Group itemsPerRow={4} doubling>
            <Card md="1/5" className="">
              <Card.Header>
                <div className="pa3 b black-60">{translate( "invoice" )}</div>
              </Card.Header>
              <Card.Content>
                <div className="">
                  <strong> {billingAddress.title}</strong> <br/>
                  {billingAddress.street} <br/>
                  {billingAddress.pcode} {billingAddress.city}<br/>
                  {billingAddress.country}<br/>
                </div>
              </Card.Content>
            </Card>
            {locationsOnDisplay}
          </Card.Group>
          {/*<Button onClick={()=>{ this.setState({showAddressBook:true})}}>Adressbuch ({locations.length}) öffnen  </Button>*/}
          {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
        </section>

        <section className="pt3">
          <div className="row-title tl">
            <h2>Zusatzinformationen</h2>
          </div>
          <Grid columns={4} stackable textAlign="left">
            { shop.session.value.extras.email_rg && <GridColumn floated="left">
              Rechnung-E-Mail&nbsp;:&nbsp;{shop.session.value.extras.email_rg}
            </GridColumn> } 
            { shop.session.value.extras.email_ab && <GridColumn floated="left">
              Auftrags-E-Mail&nbsp;:&nbsp;{shop.session.value.extras.email_ab}
            </GridColumn> } 
            { shop.session.value.extras.email_ls && <GridColumn floated="left">
              Lieferschein-E-Mail&nbsp;:&nbsp;{shop.session.value.extras.email_ls}
            </GridColumn> } 
            { shop.session.value.extras.ustid && <GridColumn floated="left">
              Umsatzsteuer-ID&nbsp;:&nbsp;{shop.session.value.extras.ustid}
            </GridColumn> } 
            { shop.session.value.extras.verband && <GridColumn floated="left">
              Verband&nbsp;:&nbsp;{shop.session.value.extras.verband}
            </GridColumn> } 
            { shop.session.value.extras.verband_mitgliedsnr && <GridColumn floated="left">
              Mitglied-ID&nbsp;:&nbsp;{shop.session.value.extras.verband_mitgliedsnr}
            </GridColumn> } 
          </Grid>            
        </section>

        {/*<section>*/}
        {/*<div className="row-title tl">*/}
        {/*<h2>Adressbuch</h2>*/}
        {/*</div>*/}
        {/*<Button onClick={() => { this.setState( { showAddressBook: true } )}}> Adressbuch öffnen </Button>*/}
        {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
        {/*</section>*/}

        <section className="mt4">
          <div className="row-title title--left">
            <h2 className="title">{translate( "your service contact" )}</h2>
          </div>
          <Button basic as={Link} to={"/form/customer_contact"}>{translate( "contact" )}</Button>
        </section>


        <section className="mt4">
          <div className="row-title title--left">
            <h2 className="title">{translate( "change Password" )}</h2>
          </div>

          <AccountReset email={shop.session.value.email}/>
        </section>

        <section className="mt4 pb5">
          <Row>
            <Col sm="1">
              <div className="row-title title--left">
                <h2 className="title">{translate( "Order History" )}</h2>
              </div>
              {orders.length >= 0 && <OrderTable orders={orders}/>}
              {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
              {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
              {!noMoreOrders && <div className="pa2 tc">
                <Button onClick={this.loadMore} loading={loading}>mehr laden</Button>
              </div>}
            </Col>
          </Row>
        </section>
        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
    )
  }
}

const OrderTable = ( { orders } ) => {
  if ( orders.length === 0 ) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="65%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="5%"/>
        </colgroup>

        <tbody>
        <tr>
          <th className="ttu">{translate( "order number" )}</th>
          <th className="ttu tc">{translate( "Dokumente" )}</th>
          <th className="ttu tr">{translate( "price" )}</th>
          <th className="ttu tc">{translate( "positions" )}</th>
          <th className="ttu tc">{translate( "date" )}</th>
          <th className="ttu tc">{translate( "status" )}</th>
        </tr>

        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow key={order.id} order={order}/> )}
        </tbody>
      </Table>
    </div>
  )
}

const OrderPreviewRow = ( { order } ) => {
  const orderDate = moment( order.register )
    .format( "DD.MM.YYYY" )
  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === "2" || order.status === 2)

  return (
    <tr>
      <td>
        <Link to={orderLink}>
          #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
        </Link>
      </td>
      <td className="tr">
        <Link to={orderLink}>
          <div className="f7 ph3 bg-black-40 white tc br-pill"> PDF ({order.extrainfo.length})</div>
        </Link>

      </td>
      <td className="tr"><Price>{order.netto}</Price></td>
      <td className="tc">{order.positions.length}</td>
      <td className="tc">
        <div className="nowrap">{orderDate}</div>
      </td>
      <td className="tc">
        <div className="flex flex-row items-center">
          <div className={"f7 ph2 bg-black-40 white tc br-pill flex flex-row items-center"}>{translate(order.extras.orderState)}</div>
        </div>
      </td>
    </tr>
  )
}

const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (
    <React.Fragment>
      <div className="address-block pb3">
        <div className=""><strong>{location.name1} {location.name2} {location.name3}</strong></div>
        <div className="block"><strong>{location.company || <span className="black-40">&hellip;</span>}</strong>
          <br/>
          {location.street || <span className="black-40">&hellip;</span>}<br/>
          {location.pcode} {location.city || <span className="black-40">&hellip;</span>}<br/>
          {location.country || <span className="black-40">&hellip;</span>}<br/>
        </div>
        <div className="pt3">
          {/*<a onClick={() => {shop.cart.setAddress( { location } )}} className="black-40" href="#">als Lieferadresse</a> <br/>*/}
          {/*<a className="black-40" href="#">Änderung beantragen</a> <br/>*/}
          {/*<a className="black-40" href="#">löschen</a> <br/>*/}
        </div>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/pages/AccountPage.js